module.exports = __webpack_public_path__ + "images/ea18962cccdcd06e9f25dab6682a3281.svg";